<template>
  <section
    :class="{
      'free-section': true,
    }"
  >
    <HeroContent
      v-if="freeHeroContent"
      v-bind="freeHeroContent"
    />
    <div
      :class="{
        'container mx-auto mt-6': true,
      }"
    >
      <div :class="{ 'grid grid-cols-12 items-center': true }">
        <div :class="{ 'order-2 col-span-12 lg:order-1 lg:col-span-6 lg:px-7': true }">
          <PortableText
            v-if="freeLeftColumnContent?.content?.standardPortableText"
            :portable-data="freeLeftColumnContent?.content?.standardPortableText"
          />
          <ReferAFriendBox
            v-if="freeLeftColumnContent?.referAFriendBox"
            v-bind="freeLeftColumnContent.referAFriendBox"
          />
        </div>
        <div :class="{ 'order-1 col-span-12 lg:order-2 lg:col-span-6 lg:px-7': true }">
          <PtcPicture
            v-if="freeRightColumnImage?.asset?._ref"
            :src="freeRightColumnImage.asset._ref"
            provider="sanity"
            :alt="'Collaboration in Onshape'"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import HeroContent from '~/components/Atoms/HeroContent/HeroContent.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import ReferAFriendBox from './ReferAFriendBox.vue';
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import type { FreeReferAFriend } from '~/sanity/types';
defineProps<FreeReferAFriend>();
</script>

<style></style>
